import currency from 'currency.js';

export default currency;
